import client from "api/client";
import { ApiEndpoints } from "api/endpoints";

import { PlateData, PlateDataInput } from "../../../backend/src/plates/types";

type PlatesQueryParams = { hallId: string };

export function getExcludedPlates(hallId: string) {
  const params: PlatesQueryParams = {
    hallId,
  };
  return client.get<PlateData[]>(ApiEndpoints.PlatesExcluded, { params });
}

export function getIncludedPlates(hallId: string) {
  const params: PlatesQueryParams = {
    hallId,
  };
  return client.get<PlateData[]>(ApiEndpoints.PlatesIncluded, { params });
}

export async function createExcludedPlate(plateData: PlateDataInput) {
  const response = await client.post<PlateData>(
    ApiEndpoints.PlatesExcluded,
    plateData
  );
  return response.data;
}

export function deleteExcludedPlate(plateId: string) {
  return client.delete<PlateData[]>(
    `${ApiEndpoints.PlatesExcluded}/${plateId}`
  );
}
